import { jsx as p, jsxs as T } from "react/jsx-runtime";
import { c as a } from "./index-65016bfa.mjs";
import { useState as ee, useRef as s, useEffect as ne } from "react";
import d, { css as _ } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as re } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Button as Q } from "./button.js";
import { Icon as te } from "./icon.js";
import { I as c, H as ae } from "./helperText-d9646f54.mjs";
import { u as $ } from "./useAccessibilityProps-2f24cf29.mjs";
import { u as oe } from "./uniqueId-321287e8.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "@fcamna/shared-icons";
const le = d.div`
  &.InlineText {
    ${({
  theme: {
    components: { inLineText: e }
  }
}) => _(e.Container)}
  }
`, pe = d.div`
  &.InlineText__OpenContainer {
    ${({
  theme: {
    components: { inLineText: e }
  }
}) => _(e.OpenContainer)}
  }
`, de = d.div`
  &.InlineText__InputContainer {
    ${({
  theme: {
    components: { inLineText: e }
  }
}) => _(e.InputContainer)}
  }
`, _e = d.div`
  &.InlineText__InlineWrapper {
    ${({
  theme: {
    components: { inLineText: e }
  }
}) => _(e.InLineWrapper)}
  }
`, Ie = d.input`
  &.InlineText__TextField {
    ${({
  theme: {
    components: { inLineText: e }
  }
}) => _(e.TextField)}
  }
`, me = d.span`
  &.InlineText__TextWrapper {
    ${({
  theme: {
    components: { inLineText: e }
  }
}) => _(e.TextWrapper)}
  }
`, ue = d.div`
  &.InlineText__SaveButtonWrapper {
    ${({
  theme: {
    components: { inLineText: e }
  }
}) => _(e.SaveButtonWrapper)}
  }
`, xe = d.span`
  &.InlineText__IconWrapper {
    ${({
  theme: {
    components: { inLineText: e }
  }
}) => _(e.IconWrapper)}
  }
`, Te = d.label`
  &.InlineText__Label {
    ${({
  theme: {
    components: { inLineText: e }
  }
}) => _(e.Label)}
  }
`, X = d.div`
  &.InlineText__HelperTextWrapper {
    ${({
  theme: {
    components: { inLineText: e }
  }
}) => _(e.HelperTextWrapper)}
  }
`, ce = d.div`
  &.InlineText__ButtonWrapper {
    ${({
  theme: {
    components: { inLineText: e }
  }
}) => _(e.ButtonWrapper)}
  }
`, D = "inline-text", Pe = ({
  size: e = "large",
  value: v,
  placeholder: B,
  label: f,
  isDisabled: o = !1,
  errorMessage: i,
  showErrorIcon: fe = !1,
  isOpen: G = !1,
  isRequired: C = !1,
  showRequiredIndicator: J = C,
  onClickOpen: L,
  onClickSave: N,
  onClickCancel: E,
  onTextChange: H,
  accessibilityOptions: n = {},
  onBlur: M,
  helperTextProp: W,
  inputState: F
}) => {
  var A, K, P, j, k, q;
  const U = re({ label: "Inline Text" }), [I, h] = ee(G), x = s(null), u = s(oe(D));
  let l = F || c.NONE, r = W;
  F || (l = i ? c.ERROR : c.NONE), W ? r = {
    ...W,
    secondaryProp: {
      ...W.secondaryProp,
      state: l
    }
  } : r = {
    [l === c.ERROR ? "secondaryProp" : "defaultProp"]: {
      helperText: i,
      id: `${l === c.ERROR ? "invalid" : "valid"}_${D}_helperText`,
      state: l
    }
  };
  const t = {
    defaultId: ((A = r == null ? void 0 : r.defaultProp) == null ? void 0 : A.id) || `default_${u.current}_message_id`,
    secondaryId: ((K = r == null ? void 0 : r.secondaryProp) == null ? void 0 : K.id) || `secondary_${u.current}_message_id`
  }, R = () => {
    N && N(), h(!I);
  }, V = (m) => {
    H && H(m.target.value);
  }, Y = (m) => {
    m.code === "Escape" ? w() : m.code === "Enter" && R();
  }, S = () => {
    L && L(), h(!I);
  };
  ne(() => {
    var m;
    I && (x != null && x.current) && ((m = x.current) == null || m.focus());
  }, [I]);
  const Z = (m) => {
    (m.code === "Enter" || m.code === "Space") && S();
  }, w = () => {
    E && E(), h(!I);
  }, z = $("button", {
    ariaLabel: ((P = n == null ? void 0 : n.component) == null ? void 0 : P.ariaLabel) || `Edit ${f}`,
    ...n == null ? void 0 : n.component,
    tabIndex: 0,
    ariaDisabled: o,
    ariaLabelledBy: `${u.current}_label ${t == null ? void 0 : t.defaultId} ${t == null ? void 0 : t.secondaryId}`
  }), b = $("button", {
    ariaLabel: ((j = n == null ? void 0 : n.saveButton) == null ? void 0 : j.ariaLabel) || "Save",
    ...n == null ? void 0 : n.saveButton,
    tabIndex: 0,
    ariaDisabled: o
  }), y = $("button", {
    ariaLabel: ((k = n == null ? void 0 : n.cancelButton) == null ? void 0 : k.ariaLabel) || "Cancel",
    ...n == null ? void 0 : n.cancelButton,
    tabIndex: 0,
    ariaDisabled: o
  }), O = $("input", {
    ariaLabel: ((q = n == null ? void 0 : n.input) == null ? void 0 : q.ariaLabel) || f,
    ...n == null ? void 0 : n.input,
    tabIndex: o ? -1 : 0,
    ariaDisabled: o,
    ariaLabelledBy: `${u.current}_label ${t == null ? void 0 : t.defaultId} ${t == null ? void 0 : t.secondaryId}`
  }), g = /* @__PURE__ */ p(
    ae,
    {
      secondaryProp: {
        id: t.secondaryId,
        ...r == null ? void 0 : r.secondaryProp,
        state: l
      },
      defaultProp: { id: t.defaultId, ...r == null ? void 0 : r.defaultProp },
      disabled: o
    }
  );
  return /* @__PURE__ */ T(
    le,
    {
      ...U,
      className: a("InlineText"),
      children: [
        /* @__PURE__ */ T(
          Te,
          {
            htmlFor: u.current,
            id: `${u.current}_label`,
            className: a("InlineText__Label"),
            children: [
              f,
              f && J && /* @__PURE__ */ T("span", { "aria-hidden": "true", children: [
                " ",
                "*"
              ] })
            ]
          }
        ),
        I ? /* @__PURE__ */ p(pe, { className: a("InlineText__OpenContainer"), children: /* @__PURE__ */ T(
          de,
          {
            className: a("InlineText__InputContainer", `InlineText__InputContainer--${e}`, {
              "InlineText__InputContainer--error": l === "error"
            }),
            children: [
              /* @__PURE__ */ p(
                Ie,
                {
                  id: u.current,
                  ref: x,
                  className: a("InlineText__TextField", `InlineText__TextField--${l}`, `InlineText__TextField--${e}`, {
                    "InlineText__TextField--open": I,
                    "InlineText__TextField--error": l === "error",
                    "InlineText__TextField--disabled": o
                  }),
                  value: v,
                  placeholder: B,
                  onChange: V,
                  "aria-label": "input",
                  "aria-required": C,
                  onKeyDown: Y,
                  onBlur: M,
                  ...O
                }
              ),
              r && /* @__PURE__ */ p(
                X,
                {
                  className: a(
                    "InlineText__HelperTextWrapper",
                    "InlineText__HelperTextWrapper--mobile",
                    `InlineText__HelperTextWrapper--${l}`,
                    { "InlineText__HelperTextWrapper--open": I }
                  ),
                  children: g
                }
              ),
              /* @__PURE__ */ T(ce, { className: a("InlineText__ButtonWrapper", `InlineText__ButtonWrapper--${e}`), children: [
                /* @__PURE__ */ p(ue, { className: a("InlineText__SaveButtonWrapper"), children: /* @__PURE__ */ p(
                  Q,
                  {
                    onClick: R,
                    size: e,
                    ...b,
                    children: "Save"
                  }
                ) }),
                /* @__PURE__ */ p(
                  Q,
                  {
                    size: e,
                    variant: "outline",
                    onClick: w,
                    ...y,
                    children: "Cancel"
                  }
                )
              ] })
            ]
          }
        ) }) : /* @__PURE__ */ T(
          _e,
          {
            className: a("InlineText__InlineWrapper", `InlineText__InlineWrapper--${e}`, {
              "InlineText__InlineWrapper--disabled": o
            }),
            ...!o && {
              onClick: S,
              onKeyDown: Z
            },
            ref: x,
            ...z,
            children: [
              /* @__PURE__ */ p(
                me,
                {
                  className: a("InlineText__TextWrapper", `InlineText__TextWrapper--${e}`, {
                    "InlineText__TextWrapper--disabled": o
                  }),
                  children: v || B
                }
              ),
              !I && /* @__PURE__ */ p(
                xe,
                {
                  className: a("InlineText__IconWrapper", {
                    "InlineText__IconWrapper--disabled": o
                  }),
                  children: /* @__PURE__ */ p(
                    te,
                    {
                      name: "edit",
                      height: "20px",
                      width: "20px"
                    }
                  )
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ p(
          X,
          {
            className: a("InlineText__HelperTextWrapper", `InlineText__HelperTextWrapper--${l}`, {
              "InlineText__HelperTextWrapper--open": I
            }),
            children: g
          }
        )
      ]
    }
  );
};
export {
  Pe as InLineText
};
